export const currenciesDa = {
  AED: 'Dirham',
  AFN: 'Afghani',
  ALL: 'Lek',
  AMD: 'Armenske dram',
  AOA: 'Kwanza',
  ARS: 'Argentinske peso',
  AUD: 'Australske dollar',
  AWG: 'Aruba-gylden',
  AZN: 'Aserbajdsjanske manat',
  BAM: 'Konvertible mark',
  BBD: 'Barbadisk dollar',
  BDT: 'Taka',
  BGN: 'Bulgariske lev',
  BHD: 'Bahrainske dinarer',
  BIF: 'Burundiske francs',
  BMD: 'Bermudianske dollar',
  BND: 'Bruneiske dollar',
  BOB: 'Boliviano',
  BRL: 'Brasilianske real',
  BSD: 'Bahamanske dollar',
  BTN: 'Ngultrum',
  BWP: 'Pula',
  BYR: 'Hviderussiske rubler',
  BZD: 'Beliziske dollar',
  CAD: 'Canadiske dollar',
  CDF: 'Congolesiske francs',
  CHF: 'Schweizerfranc',
  CLP: 'Chilenske peso',
  CNY: 'Yuan renminbi',
  COP: 'Colombiansk peso',
  CRC: 'Costaricanske colón',
  CUC: 'Cubanske konvertible peso',
  CUP: 'Cubansk peso',
  CVE: 'Kapverdiske escudo',
  CZK: 'Tjekkiske koruna',
  DJF: 'Djiboutiske francs',
  DKK: 'Danske kroner',
  DOP: 'Dominikanske peso',
  DZD: 'Algeriske dinarer',
  EGP: 'Egyptiske pund',
  EUR: 'Euro',
  ERN: 'Nakfa',
  ETB: 'Etiopiske birr',
  FJD: 'Fijianske dollar',
  FKP: 'Falklandsøerne-pund',
  GBP: 'Pund Sterling',
  GEL: 'Lari',
  GHS: 'Cedi',
  GIP: 'Gibraltar-pund',
  GMD: 'Dalasi',
  GNF: 'Guineanske francs',
  GTQ: 'Quetzal',
  GYD: 'Guyanske dollar',
  HKD: 'Kong-dollar',
  HNL: 'Lempira',
  HRK: 'Kroatiske kuna',
  HTG: 'Gourde',
  HUF: 'Forint',
  IDR: 'Rupiah',
  ILS: 'Ny Shekel',
  INR: 'Indiske rupee',
  IQD: 'Irakiske dinarer',
  IRR: 'Iranske rial',
  ISK: 'Islandske króna',
  JMD: 'Jamaicanske dollar',
  JOD: 'Jordanske dinar',
  JPY: 'Yen',
  KES: 'Kenyansk shilling',
  KGS: 'Som',
  KHR: 'Riel',
  KMF: 'Comoriske francs',
  KPW: 'Nordkoreanske won',
  KRW: 'Won',
  KWD: 'Kuwaitiske dinarer',
  KYD: 'Cayman-øerne-dollar',
  KZT: 'Tenge',
  LAK: 'Kip',
  LBP: 'Libanesiske pund',
  LKR: 'Srilankanske rupee',
  LRD: 'Liberiansk dollar',
  LSL: 'Loti',
  LYD: 'Libyske dinarer',
  MAD: 'Marokkanske dirham',
  MDL: 'Moldoviske leu',
  MGA: 'Madagaskiske ariary',
  MKD: 'Denar',
  MMK: 'Kyat',
  MNT: 'Tugrik',
  MOP: 'Pataca',
  MRO: 'Ouguiya',
  MUR: 'Mauritiske rupee',
  MVR: 'Rufiyaa',
  MWK: 'Kwacha',
  MXN: 'Mexicanske peso',
  MYR: 'Malaysiske ringgit',
  MZN: 'Merical',
  NAD: 'Namibiske dollar',
  NGN: 'Naira',
  NIO: 'Cordoba Oro',
  NOK: 'Norske kroner',
  NPR: 'Nepalesiske rupee',
  NZD: 'New Zealand-dollar',
  OMR: 'Omansk rial',
  PAB: 'Balboa',
  PEN: 'Ny sol',
  PGK: 'Kina',
  PHP: 'Filippinske peso',
  PKR: 'Pakistanske rupee',
  PLN: 'Zloty',
  PYG: 'Guaraní',
  QAR: 'Qatar rial',
  RON: 'Leu',
  RSD: 'Serbiske dinarer',
  RUB: 'Russiske rubler',
  RWF: 'Rwandiske francs',
  SAR: 'Saudiarabiske riyal',
  SBD: 'Salomonøerne-dollar',
  SCR: 'Seychellisk rupee',
  SDG: 'Sudaniske dinarer',
  SEK: 'Svenske kronar',
  SGD: 'Singaporeanske dollar',
  SHP: 'Helena-pund',
  SLL: 'Leone',
  SOS: 'Somalisk shilling',
  SRD: 'Surinam dollar',
  SSP: 'Sydsudanske pound',
  STD: 'Dobra',
  SYP: 'Syriske pund',
  SZL: 'Lilangeni',
  THB: 'Baht',
  TJS: 'Somoni',
  TMM: 'Manat',
  TND: 'Tunesiske dinarer',
  TOP: "Pa'anga",
  TRY: 'Nytyrkiske lira',
  TTD: 'Trinidad og Tobago-dollar',
  TWD: 'Nytaiwanske dollar',
  TZS: 'Tanzanisk shilling',
  UAH: 'Hryvnia',
  UGX: 'Ugandiske shilling',
  USD: 'Amerikanske dollar',
  UYU: 'Uruguayske peso',
  UZS: 'Usbekiske sum',
  VEF: 'Bolivar',
  VND: 'Dong',
  VUV: 'Vatu',
  WST: 'Tala',
  YER: 'Yeminitiske rial',
  ZAR: 'Rand',
  ZMW: 'Kwacha',
  ZWL: 'Zimbabwiske dollar',
  ANG: 'Nederlandske Antiller-gylden',
} as const;
